"use client";

import { Toast as ToastPrimitive } from "radix-ui";
import { type FC, type PropsWithChildren, useCallback, useState } from "react";
import { Toast, type ToastProps } from "../..";
import { NotificationContext, type ToastContextValue } from "../context/NotificationContext";

export const DEFAULT_DURATION = 5000;

export const NotificationProvider: FC<PropsWithChildren> = ({ children }) => {
	const [notifications, setNotifications] = useState<ToastProps[]>([]);

	const notify: ToastContextValue["notify"] = useCallback((notification) => {
		setNotifications((prev) => [...prev, { identifier: Date.now(), ...notification }]);
	}, []);

	const remove: ToastContextValue["remove"] = useCallback((identifier) => {
		setNotifications((prev) =>
			prev.filter((notification) => notification.identifier !== identifier),
		);
	}, []);

	return (
		<NotificationContext.Provider value={{ notify, remove }}>
			{children}

			<ToastPrimitive.Provider duration={DEFAULT_DURATION}>
				{notifications.map((item) => (
					<Toast {...item} key={item.identifier} />
				))}

				<ToastPrimitive.Viewport className="fixed top-[calc(var(--header-y,0rem)+1rem)] right-[var(--viewport-spacing)] z-notification w-[calc(100%-2rem)] max-w-md space-y-4 [--viewport-spacing:1rem] sm:top-[calc(var(--header-y,1.5rem)+1rem)] sm:w-full sm:[--viewport-spacing:2.5rem]" />
			</ToastPrimitive.Provider>
		</NotificationContext.Provider>
	);
};
